export const wizardErrors = {
  CLIENT: 'errors.treatment-wizard.client',
  DEVICE: 'errors.treatment-wizard.device',
  PRODUCT_CONFIGURATION: 'errors.treatment-wizard.product-configuration',
  THERAPY_TYPE: 'errors.treatment-wizard.therapy-type',
};
